<template>
  <div class="home">
    <div id="home">
      <!-- 图表 -->
      <div id="home-canvas"></div>
    </div>
    <!-- 头部 -->
    <home-header></home-header>
    <!-- 底部 -->
    <div class="footer-bg"></div>
  </div>
</template>
<script>
import ThreeDimensional from "@/assets/three/ThreeDimensional";
import homeHeader from "@/components/header/header.vue";
import machineTip from "@/module/machineTip.vue";
// api接口
import { machine } from "@/assets/api/chartData";
var ThreeDimen;

export default {
  components: {
    homeHeader,
    machineTip,
  },
  data() {
    return {

    };
  },
  mounted() {
    window.GetModelLoader =  this.GetModelLoader;
    this.$nextTick(() => {

      //构建三维场景内容
      //传入div id，即可在指定的div中构建三维场景
      ThreeDimen = new ThreeDimensional("home-canvas");

      /**
       * @接入数据
       * 具体传值方式请看源码
       * 可根据自身需求修改SetInfoData函数
       */
      // setInterval(() => {
      //   ThreeDimen.SetInfoData(datas)
      // }, 2000);

      //开启随机数据，接入真实数据后，不需要再调用该函数
      ThreeDimen.UpdateData();

      //调用漫游动画
      //ThreeDimen.PlayCameraAnimation()

      //停止漫游动画
      //ThreeDimen.StopCameraAnimation();
      
    });

    
    
    

  },
  methods: {
    GetModelLoader(loader){
      console.log( "加载进度 ： " + loader + "%");
    },
  },
};
</script>

<style src='./index.css' />